<template>
    <div class="mt-2 w-full">
        <button
            type="button"
            @click="openConfirmModal"
            :disabled="disabled"
            class="group mb-1 flex w-full cursor-pointer items-center justify-center gap-2"
        >
            <RotateCwIcon class="size-4 shrink-0 text-gray-500 transition group-hover:rotate-180" />

            <span class="flex items-center gap-1">
                <span class="text-sm text-gray-500" v-text="$t('pages.product_detail_page.product_info.product_button.start_over.label')" />
            </span>
        </button>

        <StartOverConfirmModal
            v-model="isConfirmModalOpen"
            :title="$t('pages.product_detail_page.product_info.product_button.start_over.confirm_modal.title')"
            :description="$t('pages.product_detail_page.product_info.product_button.start_over.confirm_modal.description')"
            :confirm-label="$t('pages.product_detail_page.product_info.product_button.start_over.confirm_modal.confirm')"
            :cancel-label="$t('pages.product_detail_page.product_info.product_button.start_over.confirm_modal.cancel')"
            @confirm="startOver"
            @cancel="closeConfirmModal"
        />
    </div>
</template>

<script setup lang="ts">
import StartOverConfirmModal from '@/pages/product-page/partials/product-info/partials/StartOverConfirmModal.vue';
import { useProductStore } from '@/stores/products/ProductStore';
import { useMediaclipSessionStore } from '@/stores/tool/MediaclipSessionStore';
import { RotateCwIcon } from '@lucide/vue';
import { ref } from 'vue';

type ButtonProps = {
    disabled?: boolean;
};

withDefaults(defineProps<ButtonProps>(), {
    disabled: false,
});

const productStore = useProductStore();
const sessionStore = useMediaclipSessionStore();

const isConfirmModalOpen = ref<boolean>(false);

function openConfirmModal(): void {
    isConfirmModalOpen.value = true;
}

function closeConfirmModal(): void {
    isConfirmModalOpen.value = false;
}

function startOver(): void {
    productStore.resetToDefaults();
    sessionStore.clear();

    if (!window.mediaclip) {
        return;
    }

    window.mediaclip.hub.destroy(true);
}
</script>
